module.exports = __webpack_public_path__ + "img/login.888556d0.jpg";